// extracted by mini-css-extract-plugin
export default {"card":"style_card__hPPt5","card__header":"style_card__header__Cc3DU","card__value":"style_card__value__JeYN8","card__graphic":"style_card__graphic__rhqyD"};